
import { Component, Prop, Vue } from 'vue-property-decorator';
import {} from '@/api/customer';
import { UserModule } from '@/store/modules/user';
import GroupCustomer from './GroupCustomer.vue';
import GroupAddress from './GroupAddress.vue';
import GroupFault from './GroupFault.vue';
import GroupTag from './GroupTag.vue';
import GroupDeptlist from '@/components/DeptLev/index.vue';
import GroupDevicelist from "./GroupDevice.vue"
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import Index from '@/components/BbsDialog/index.vue';

@Component({
  name: 'GroupDialogStep1',
  components: {
    GroupCustomer,
    GroupAddress,
    GroupFault,
    GroupTag,
    GroupDeptlist,
    GroupDevicelist,
    Index
  }
})
export default class extends Vue {
  // @Prop({
  //   type: Boolean,
  //   default: false
  // })
  // groupCombineVisible!: Boolean;
  @Prop({
    type: Object,
    default: () => ({})
  })
  editorData!: any;
  @Prop({
    type: Object,
    default: () => ({})
  })
  selectPopData!: any;

  private activeName = 'first';
  private customerSearch: any = {
    name: '',
    address: ''
  };
  private groupRadio = '1';
  private groupRadioOptions = [
    {
      isShow: true,
      label: '1',
      name: '客户'
    },
    {
      isShow: true,
      label: '2',
      name: '地址'
    },
    {
      isShow: true,
      label: '3',
      name: '故障现象'
    },
    {
      isShow: true,
      label: '4',
      name: '标签'
    },
    {
      isShow: true,
      label: '5',
      name: '报修部门'
    },
    {
      isShow: true,
      label: '6',
      name: '设备'
    },
    {
      isShow: true,
      label: '7',
      name: '无'
    }
  ];
  private listLoading = false;
  private isPrev = false;
  private locData: any = {};
  private servicerCompanyId=''
  private vipLev:number=1;


  created() {
    this.servicerCompanyId = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    if(UserModule.getCompany&&UserModule.getCompany.vip_level){
      this.vipLev=parseInt(UserModule.getCompany.vip_level.substr(0, 1));
    }

    this.groupRadioOptions[0].isShow = checkPermissionCompany(
      UserModule.getCompanyId,
      Type.CUSTOMER_COMPANY
    );
    this.groupRadioOptions[1].isShow =
      checkPermissionCompany(UserModule.getCompanyId, Type.pca) ||
      checkPermissionCompany(UserModule.getCompanyId, Type.myselfPCALs);
    this.groupRadioOptions[2].isShow = checkPermissionCompany(
      UserModule.getCompanyId,
      Type.FAULT_PHENOMENON
    );
    this.groupRadioOptions[3].isShow = checkPermissionCompany(
      UserModule.getCompanyId,
      Type.tag
    );
    this.groupRadioOptions[4].isShow = this.vipLev!==3
    this.groupRadioOptions[5].isShow = checkPermissionCompany(
      UserModule.getCompanyId,
      Type.device
    );

    if (!this.groupRadioOptions[0].isShow) {
      if (this.groupRadioOptions[1].isShow) {
        this.groupRadio = '2';
      } else {
        if (this.groupRadioOptions[2].isShow) {
          this.groupRadio = '3';
        } else {
          if (this.groupRadioOptions[3].isShow) {
            this.groupRadio = '4';
          } else {
            if (this.groupRadioOptions[4].isShow) {
              this.groupRadio = '5';
            } else {
              this.groupRadio = '6';
            }
          }
        }
      }
    }
    this.oneWhere = '';
    if (
      this.editorData &&
      this.editorData.group_push &&
      this.editorData.group_push.where_one
    ) {
      this.twoWhere = '';
      if (this.editorData.group_push.where_one.customer_list) {
        this.selcetCustomer =
          this.editorData.group_push.where_one.customer_list;
        this.oneWhere = 'customer_list';
      } else {
        this.selcetCustomer = [];
      }
      if (this.editorData.group_push.where_one.address_list) {
        this.selectAddress = this.editorData.group_push.where_one.address_list;
        this.oneWhere = 'address_list';
      } else {
        this.selectAddress = [];
      }
      if (this.editorData.group_push.where_one.fault_phenomenon_list) {
        this.selectFault =
          this.editorData.group_push.where_one.fault_phenomenon_list;
        this.oneWhere = 'fault_phenomenon_list';
      } else {
        this.selectFault = [];
      }
      if (this.editorData.group_push.where_one.tag_list) {
        this.selectTags = this.editorData.group_push.where_one.tag_list;
        this.oneWhere = 'tag_list';
      } else {
        this.selectTags = [];
      }
      if (this.editorData.group_push.where_one.department_list) {
        this.selcetDeptCustomer = this.editorData.group_push.where_one.department_list;
        this.oneWhere = 'department_list';
      } else {
        this.selcetDeptCustomer = [];
      }
      if (this.editorData.group_push.where_one.device_list) {
        this.selectDevice =
          this.editorData.group_push.where_one.device_list;
        this.oneWhere = 'device_list';
      } else {
        this.selectDevice = [];
      }
      if (this.selcetCustomer && this.selcetCustomer.length > 0 &&
          this.groupRadioOptions[0].isShow) {
        this.groupRadio = '1';
      } else if (
        this.selectAddress &&
          this.selectAddress.length > 0 &&
          this.groupRadioOptions[1].isShow
      ) {
        this.groupRadio = '2';
      } else if (
        this.selectFault &&
          this.selectFault.length > 0 &&
          this.groupRadioOptions[2].isShow
      ) {
        this.groupRadio = '3';
      } else if (
        this.selectTags &&
          this.selectTags.length > 0 &&
          this.groupRadioOptions[3].isShow
      ) {
        this.groupRadio = '4';
      } else if (
        this.selcetDeptCustomer &&
          this.selcetDeptCustomer.length > 0 &&
          this.groupRadioOptions[4].isShow
      ) {
        this.groupRadio = '5';
      } else if (
        this.selectDevice &&
          this.selectDevice.length > 0 &&
          this.groupRadioOptions[5].isShow
      ) {
        this.groupRadio = '6';
      }
    } else {
      this.twoWhere = '';
      this.selcetCustomer = [];
      this.selectAddress = [];
      this.selectFault = [];
      this.selectTags = [];
      this.selcetDeptCustomer = [];
    }
  }

  private oneWhere = '';
  private twoWhere = '';
  private selcetCustomer: any = [];
  private selectAddress: any = [];
  private selectFault: any = [];
  private selectTags: any = [];
  private selcetDeptCustomer: any = [];
  private selectDevice:any=[];
  private checkedCustomerChange(val: any) {

    if (this.activeName === 'second') {
      this.twoWhere = 'customer_list';
      if (this.oneWhere === 'tag_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'fault_phenomenon_list') {
        this.selectTags = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'address_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'department_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'device_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
      }
    } else {
      this.selectTags = [];
      this.selectFault = [];
      this.selectAddress = [];
      this.selcetDeptCustomer = [];
      this.selectDevice = [];
      this.oneWhere = 'customer_list';
    }
    this.selcetCustomer = val;
  }
  private addressSelectedChange(val: any) {
    if (this.activeName === 'second') {
      this.twoWhere = 'address_list';
      if (this.oneWhere === 'tag_list') {
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'fault_phenomenon_list') {
        this.selectTags = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'customer_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'department_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'device_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
    } else {
      this.selcetCustomer = [];
      this.selectTags = [];
      this.selectFault = [];
      this.selcetDeptCustomer = [];
      this.selectDevice = [];
      this.oneWhere = 'address_list';
    }
    this.selectAddress = val;
  }
  private checkedFaultChange(val: any) {
    if (this.activeName === 'second') {
      this.twoWhere = 'fault_phenomenon_list';
      if (this.oneWhere === 'tag_list') {
        this.selcetCustomer = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'address_list') {
        this.selectTags = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'customer_list') {
        this.selectTags = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'department_list') {
        this.selectTags = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'device_list') {
        this.selectTags = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
    } else {
      this.selcetCustomer = [];
      this.selectTags = [];
      this.selectAddress = [];
      this.selcetDeptCustomer = [];
      this.selectDevice = [];
      this.oneWhere = 'fault_phenomenon_list';
    }
    this.selectFault = val;
  }
  private checkedTagChange(val: any) {
    if (this.activeName === 'second') {
      this.twoWhere = 'tag_list';
      if (this.oneWhere === 'fault_phenomenon_list') {
        this.selcetCustomer = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'address_list') {
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'customer_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'department_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'device_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
    } else {
      this.selcetCustomer = [];
      this.selectFault = [];
      this.selectAddress = [];
      this.selcetDeptCustomer = [];
      this.selectDevice = [];
      this.oneWhere = 'tag_list';
    }
    this.selectTags = val;
  }
  private changeDeptChange(val: any) {
    if (this.activeName === 'second') {
      this.twoWhere = 'department_list';
      if (this.oneWhere === 'fault_phenomenon_list') {
        this.selcetCustomer = [];
        this.selectAddress = [];
        this.selectTags = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'address_list') {
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selectTags = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'customer_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selectTags = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'tag_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      } else if (this.oneWhere === 'device_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selectTags = [];
      }
    } else {
      this.selectTags = [];
      this.selcetCustomer = [];
      this.selectFault = [];
      this.selectAddress = [];
      this.selectDevice = [];
      this.oneWhere = 'department_list';
    }
    this.selcetDeptCustomer = val;
  }
  private changeDeviceChange(val:any) {
    if (this.activeName === 'second') {
      this.twoWhere = 'device_list';
      if (this.oneWhere === 'fault_phenomenon_list') {
        this.selcetCustomer = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectTags = [];
      } else if (this.oneWhere === 'address_list') {
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
        this.selectTags = [];
      } else if (this.oneWhere === 'customer_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectTags = [];
      } else if (this.oneWhere === 'department_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selectTags = [];
      } else if (this.oneWhere === 'tag_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
    } else {
      this.selectTags = [];
      this.selcetCustomer = [];
      this.selectFault = [];
      this.selectAddress = [];
      this.selcetDeptCustomer = [];
      this.oneWhere = 'device_list';
    
    }
    this.selectDevice = val;
  }
  private groupRadioHandle() {
    if (this.activeName === 'first') {
      this.selectTags = [];
      this.selectFault = [];
      this.selectAddress = [];
      this.selcetCustomer = [];
      this.selcetDeptCustomer = [];
      this.selectDevice = [];
    } else {
      if (this.oneWhere === 'tag_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = []
      }
      if (this.oneWhere === 'fault_phenomenon_list') {
        this.selectTags = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = []
      }
      if (this.oneWhere === 'address_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = []
      }
      if (this.oneWhere === 'customer_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = []
      }
      if (this.oneWhere === 'department_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selectDevice = []
      }
      if (this.oneWhere === 'device_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
    }
    // if (this.groupRadio === '6') {
    //   this.oneWhere = 'device_list'
    // }
  }

  private preHandle() {
    this.activeName = 'first';
    this.isPrev = false;
    this.groupRadioOptions[0].isShow = checkPermissionCompany(
      UserModule.getCompanyId,
      Type.CUSTOMER_COMPANY
    );
    this.groupRadioOptions[1].isShow =
      checkPermissionCompany(UserModule.getCompanyId, Type.pca) ||
      checkPermissionCompany(UserModule.getCompanyId, Type.myselfPCALs);
    this.groupRadioOptions[2].isShow = checkPermissionCompany(
      UserModule.getCompanyId,
      Type.FAULT_PHENOMENON
    );
    this.groupRadioOptions[3].isShow = checkPermissionCompany(
      UserModule.getCompanyId,
      Type.tag
    );
    this.groupRadioOptions[4].isShow = this.vipLev!==3
    this.groupRadioOptions[5].isShow = checkPermissionCompany(
      UserModule.getCompanyId,
      Type.device
    );
    if (this.oneWhere === 'tag_list') {
      this.groupRadio = '4';
      if (this.twoWhere === 'fault_phenomenon_list') {
        this.selcetCustomer = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'address_list') {
        this.selcetCustomer = [];
        this.selectFault = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'customer_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'department_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'device_list') {
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
    }
    if (this.oneWhere === 'fault_phenomenon_list') {
      this.groupRadio = '3';
      if (this.twoWhere === 'tag_list') {
        this.selcetCustomer = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'address_list') {
        this.selcetCustomer = [];
        this.selectTags = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'customer_list') {
        this.selectTags = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'department_list') {
        this.selectTags = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'device_list') {
        this.selectTags = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
    }
    if (this.oneWhere === 'address_list') {
      this.groupRadio = '2';
      if (this.twoWhere === 'tag_list') {
        this.selcetCustomer = [];
        this.selectFault = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'fault_phenomenon_list') {
        this.selcetCustomer = [];
        this.selectTags = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'customer_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'department_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'device_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
    }
    if (this.oneWhere === 'customer_list') {
      this.groupRadio = '1';
      if (this.twoWhere === 'tag_list') {
        this.selectAddress = [];
        this.selectFault = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'fault_phenomenon_list') {
        this.selectAddress = [];
        this.selectTags = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'address_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetDeptCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'department_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'device_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
      }
    }
    if (this.oneWhere === 'department_list') {
      this.groupRadio = '5';
      if (this.twoWhere === 'tag_list') {
        this.selectAddress = [];
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'fault_phenomenon_list') {
        this.selectAddress = [];
        this.selectTags = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'address_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'customer_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selectDevice = [];
      }
      if (this.twoWhere === 'device_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
      }
    }
    if (this.oneWhere === 'device_list') {
      this.groupRadio = '6';
      if (this.twoWhere === 'tag_list') {
        this.selectAddress = [];
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
      if (this.twoWhere === 'fault_phenomenon_list') {
        this.selectAddress = [];
        this.selectTags = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
      if (this.twoWhere === 'address_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selcetCustomer = [];
        this.selcetDeptCustomer = [];
      }
      if (this.twoWhere === 'customer_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetDeptCustomer = [];
      }
      if (this.twoWhere === 'department_list') {
        this.selectTags = [];
        this.selectFault = [];
        this.selectAddress = [];
        this.selcetCustomer = [];
      }
    }
    this.$forceUpdate();
    this.$emit('prevParent');
  }
  private nextHandle() {


    // if (this.oneWhere === 'device_list') {
    //   //需要判断设备是否为空
    //   if {
    //     this.showErrorMsg('请选择组合条件');
    //     return;
    //   }
    //   this.groupRadioOptions[0].isShow = false;
    //   this.groupRadioOptions[1].isShow = false;
    //   this.groupRadioOptions[2].isShow = false;
    //   this.groupRadioOptions[3].isShow = false;
    //   this.groupRadioOptions[4].isShow = false;
    //   this.groupRadioOptions[5].isShow = false;
    //   this.groupRadio = '7';
    // } else {

    if (
      (!this.selcetCustomer || this.selcetCustomer.length < 1) &&
      (!this.selectAddress || this.selectAddress.length < 1) &&
      (!this.selectFault || this.selectFault.length < 1) &&
      (!this.selectTags || this.selectTags.length < 1) &&
      (!this.selcetDeptCustomer || this.selcetDeptCustomer.length < 1) &&
      (!this.selectDevice || this.selectDevice.length < 1) 
    ) {
      this.showErrorMsg('请选择组合条件');
      return;
    }
    //设置第二条件及根据条件一清空条件
    if (
      this.editorData &&
      this.editorData.group_push &&
      this.editorData.group_push.where_two
    ) {
      //如果接口返回条件二有数据 根据条件自动选中条件二 twoWhere 并赋值
      if (this.editorData.group_push.where_two.customer_list) {
        this.selcetCustomer =
          this.editorData.group_push.where_two.customer_list || [];
        this.twoWhere = 'customer_list';
      } else {
        if (this.oneWhere !== 'customer_list') {
          this.selcetCustomer = [];
        }
      }
      if (this.editorData.group_push.where_two.address_list) {
        this.selectAddress =
          this.editorData.group_push.where_two.address_list || [];
        this.twoWhere = 'address_list';
      } else {
        if (this.oneWhere !== 'address_list') {
          this.selectAddress = [];
        }
      }
      if (this.editorData.group_push.where_two.fault_phenomenon_list) {
        this.selectFault =
          this.editorData.group_push.where_two.fault_phenomenon_list || [];
        this.twoWhere = 'fault_phenomenon_list';
      } else {
        if (this.oneWhere !== 'fault_phenomenon_list') {
          this.selectFault = [];
        }
      }
      if (this.editorData.group_push.where_two.tag_list) {
        this.selectTags = this.editorData.group_push.where_two.tag_list || [];
        this.twoWhere = 'tag_list';
      } else {
        if (this.oneWhere !== 'tag_list') {
          this.selectTags = [];
        }
      }
      if (this.editorData.group_push.where_two.department_list) {
        this.selcetDeptCustomer = this.editorData.group_push.where_two.department_list || [];
        this.twoWhere = 'department_list';
      } else {
        if (this.oneWhere !== 'department_list') {
          this.selcetDeptCustomer = [];
        }
      }
      if (this.editorData.group_push.where_two.device_list) {
        this.selectDevice =
          this.editorData.group_push.where_two.device_list || [];
        this.twoWhere = 'device_list';
      } else {
        if (this.oneWhere !== 'device_list') {
          this.selectDevice = [];
        }
      }
    } else {
      //条件二无数据 清空条件一数据
      if (this.oneWhere !== 'customer_list') {
        this.selcetCustomer = [];
      }
      if (this.oneWhere !== 'address_list') {
        this.selectAddress = [];
      }
      if (this.oneWhere !== 'fault_phenomenon_list') {
        this.selectFault = [];
      }
      if (this.oneWhere !== 'tag_list') {
        this.selectTags = [];
      }
      if (this.oneWhere !== 'department_list') {
        this.selcetDeptCustomer = [];
      }
      if (this.oneWhere !== 'device_list') {
        this.selectDevice = [];
      }
    }
    
    if (this.selcetCustomer && this.selcetCustomer.length > 0) {
      if (this.oneWhere === 'customer_list') {
        this.groupRadioOptions[0].isShow = false;
      } else {
        this.groupRadioOptions[0].isShow = true;
      }
    }
    if (this.selectAddress && this.selectAddress.length > 0) {
      if (this.oneWhere === 'address_list') {
        this.groupRadioOptions[1].isShow = false;
      } else {
        this.groupRadioOptions[1].isShow = true;
      }
    }
    if (this.selectFault && this.selectFault.length > 0) {
      if (this.oneWhere === 'fault_phenomenon_list') {
        this.groupRadioOptions[2].isShow = false;
      } else {
        this.groupRadioOptions[2].isShow = true;
      }
    }
    if (this.selectTags && this.selectTags.length > 0) {
      if (this.oneWhere === 'tag_list') {
        this.groupRadioOptions[3].isShow = false;
      } else {
        this.groupRadioOptions[3].isShow = true;
      }
    }
    if (this.selcetDeptCustomer && this.selcetDeptCustomer.length > 0) {
      if (this.oneWhere === 'department_list') {
        this.groupRadioOptions[4].isShow = false;
        
      } else {
        this.groupRadioOptions[4].isShow = true;
      }
    }
    if (this.selectDevice && this.selectDevice.length > 0) {
      if (this.oneWhere === 'device_list') {
        // this.groupRadioOptions[5].isShow = false;
        //隐藏其它
        this.groupRadioOptions[0].isShow = false;
        this.groupRadioOptions[1].isShow = false;
        this.groupRadioOptions[2].isShow = false;
        this.groupRadioOptions[3].isShow = false;
        this.groupRadioOptions[4].isShow = false;
        this.groupRadioOptions[5].isShow = false;
      } else {
        this.groupRadioOptions[5].isShow = true;
      }
    }
    if (this.selcetCustomer && this.selcetCustomer.length > 0 &&
        this.groupRadioOptions[0].isShow) {
      this.groupRadio = '1';
    } else if (
      this.selectAddress &&
        this.selectAddress.length > 0 &&
        this.groupRadioOptions[1].isShow
    ) {
      this.groupRadio = '2';
    } else if (
      this.selectFault &&
        this.selectFault.length > 0 &&
        this.groupRadioOptions[2].isShow
    ) {
      this.groupRadio = '3';
    } else if (
      this.selectTags &&
        this.selectTags.length > 0 &&
        this.groupRadioOptions[3].isShow
    ) {
      this.groupRadio = '4';
    } else if (
      this.selcetDeptCustomer &&
        this.selcetDeptCustomer.length > 0 &&
        this.groupRadioOptions[4].isShow
    ) {
      this.groupRadio = '5';
    } else if (
      this.selectDevice &&
        this.selectDevice.length > 0 &&
        this.groupRadioOptions[5].isShow
    ) {
      //选择无
      this.groupRadio = '7';
    }  else {
        if (this.groupRadioOptions[0].isShow) {
          this.groupRadio = '1';
        } else if (this.groupRadioOptions[1].isShow) {
          this.groupRadio = '2';
        } else if (this.groupRadioOptions[2].isShow) {
          this.groupRadio = '3';
        } else if (this.groupRadioOptions[3].isShow) {
          this.groupRadio = '4';
        } else if (this.groupRadioOptions[4].isShow) {
          this.groupRadio = '5';
        } else if (this.groupRadioOptions[5].isShow) {
          this.groupRadio = '6';
        } else if (this.groupRadioOptions[6].isShow) {
          this.groupRadio = '7';
        }
        //如果是编辑过来 条件二无选择无
        if(this.editorData.group_push){
          this.groupRadio = '7';
        }
      
      }


          
    // else if (this.editorData &&
    //   this.editorData.group_push && this.oneWhere === 'device_list') {
    //     this.groupRadio = '7';
    //   } 
  
    this.activeName = 'second';
    this.isPrev = true;
    this.$emit('nextParent');
  }

  private nextNormalHandle(val:number) {
    
    if (this.groupRadio !== '7') {
      if (this.oneWhere === 'customer_list') {
        if (
          (!this.selectAddress || this.selectAddress.length < 1) &&
          (!this.selectFault || this.selectFault.length < 1) &&
          (!this.selectTags || this.selectTags.length < 1) &&
          (!this.selcetDeptCustomer || this.selcetDeptCustomer.length < 1) &&
          (!this.selectDevice || this.selectDevice.length < 1)
        ) {
          this.showErrorMsg('请选择组合条件');
          return;
        }
      }
      if (this.oneWhere === 'address_list') {
        if (
          (!this.selcetCustomer || this.selcetCustomer.length < 1) &&
          (!this.selectFault || this.selectFault.length < 1) &&
          (!this.selectTags || this.selectTags.length < 1) &&
          (!this.selcetDeptCustomer || this.selcetDeptCustomer.length < 1) &&
          (!this.selectDevice || this.selectDevice.length < 1)
        ) {
          this.showErrorMsg('请选择组合条件');
          return;
        }
      }
      if (this.oneWhere === 'fault_phenomenon_list') {
        if (
          (!this.selcetCustomer || this.selcetCustomer.length < 1) &&
          (!this.selectAddress || this.selectAddress.length < 1) &&
          (!this.selectTags || this.selectTags.length < 1) &&
          (!this.selcetDeptCustomer || this.selcetDeptCustomer.length < 1) &&
          (!this.selectDevice || this.selectDevice.length < 1)
        ) {
          this.showErrorMsg('请选择组合条件');
          return;
        }
      }
      if (this.oneWhere === 'tag_list') {
        if (
          (!this.selcetCustomer || this.selcetCustomer.length < 1) &&
          (!this.selectAddress || this.selectAddress.length < 1) &&
          (!this.selectFault || this.selectFault.length < 1) &&
          (!this.selcetDeptCustomer || this.selcetDeptCustomer.length < 1) &&
          (!this.selectDevice || this.selectDevice.length < 1)
        ) {
          this.showErrorMsg('请选择组合条件');
          return;
        }
      }
      if (this.oneWhere === 'department_list') {
        if (
          (!this.selcetCustomer || this.selcetCustomer.length < 1) &&
          (!this.selectAddress || this.selectAddress.length < 1) &&
          (!this.selectFault || this.selectFault.length < 1) &&
          (!this.selectTags || this.selectTags.length < 1) &&
          (!this.selectDevice || this.selectDevice.length < 1)
        ) {
          this.showErrorMsg('请选择组合条件');
          return;
        }
      }
    }else{
      //如果
      this.twoWhere = '';
    }

    // 返回给 父级数据
    let dialogResult: any = {};
    dialogResult.customer = this.selcetCustomer;
    dialogResult.address = this.selectAddress;
    dialogResult.fault = this.selectFault;
    dialogResult.tags = this.selectTags;
    dialogResult.dept = this.selcetDeptCustomer;
    dialogResult.device = this.selectDevice;
    dialogResult.oneWhere = this.oneWhere;
    dialogResult.twoWhere = this.twoWhere;
    this.$emit('selectedStep', dialogResult);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
